import { Component, OnInit,Inject,Output, EventEmitter ,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-edit-ecowas-whitelist-config-table',
  templateUrl: './edit-ecowas-whitelist-config-table.component.html',
  styleUrls: ['./edit-ecowas-whitelist-config-table.component.scss']
})
export class EditEcowasWhitelistConfigTableComponent implements OnInit {
  @Output() refreshTableData = new EventEmitter();
  updateWhitelistConfigForm :FormGroup;
  itemdata:any;
 cameFrom:any;
 Type:any;
  constructor(public dialogRef: MatDialogRef<EditEcowasWhitelistConfigTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder:FormBuilder , private endpointsService: EndpointsService, private backendApiService: BackendApiService,
   private router:Router) { }

  ngOnInit(): void {
    this.spinnerService.show();
     this.itemdata = this.data.rowData
     this.cameFrom = this.data.came
     this.Type = this.data.type;
     console.log('came',this.cameFrom)
     console.log('itemDAta',this.itemdata)
     console.log("ddd",this.itemdata.created_date)
     console.log('cameeee',this.Type)
    this.updatewhitelist()
  }
  updatewhitelist(){
    this.updateWhitelistConfigForm =  this.formBuilder.group({
      orgId :[this.itemdata.orgId],
      msisdn:[this.itemdata.msisdn],
      created_date:[this.itemdata.created_date],
      imsi:[this.itemdata.imsi],
      remarks:[this.itemdata.remarks],
      message_type:[this.itemdata.message_type]
    })
  }
  onClose(){
    this.dialogRef.close();
  }
  onUpdate(){
    this.spinnerService.show();
    this.backendApiService.callToApi(this.endpointsService.URL_UPDATE_WHITELIST_CONFIG +
      '&orgId=' + this.updateWhitelistConfigForm.get('orgId').value + '&type='+ this.Type +
      '&msisdn=' + this.updateWhitelistConfigForm.get('msisdn').value+
      '&created_date=' + this.updateWhitelistConfigForm.get('created_date').value+
      '&imsi=' + this.updateWhitelistConfigForm.get('imsi').value+
      '&remarks=' + this.updateWhitelistConfigForm.get('remarks').value+
      '&message_type=' + this.updateWhitelistConfigForm.get('message_type').value
      
      )
      .subscribe(response => {
        console.log("responseeee",response)
        this.spinnerService.hide();
        if (response === null || response === false ||  response === "{\"status\" : \"false\"}") {
          alert('Not updated');
          // this.dialogRef.close(false);

          return;
        } else {
          alert('updated successfully');
          this.dialogRef.close();
          // this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard']).then();
          
          

          // this.dialogRef.close();
          // this.spinnerService.show();
          // //this.refreshTableData.emit();
          if(this.cameFrom == 'rrms'){
          this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard'])
          }else{
            this.router.navigate(['/service-live-dashboard/sms-pdp-service-live-dashboard'])
          }
        }
  })
  }
  onReset(){
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    
  }
}
